const themes = {
  brand: {
    primary: { light: '#532E88', dark: '#7B5BA8' },
    primaryLight: { light: '#706CE0', dark: '#706CE0' },
    secondary: { light: '#F4F8FF', dark: '#F4F8FF' },
    tertiary: { light: '#50E4DE', dark: '#50E4DE' },
    accent: { light: '#D02540', dark: '#D02540' },
    foreground: { light: '#333333', dark: '#e0e0e0' },
    'foreground-immutable': { light: '#e0e0e0', dark: '#e0e0e0' },
    background: { light: '#FFFFFF', dark: '#1f1f1f' },
    muted:  { light: '#ffffff', dark: '#303030' },
    'muted-accent': { light: '#6b6b6b', dark: '#6b6b6b' },
  },

  feedback: {
    info: { light: '#2EC9D3', dark: '#2EC9D3' },
    success: { light: '#44AB96', dark: '#44AB96' },
    warning: { light: '#FADD8F', dark: '#FADD8F' },
    warningLight: { light: '#FFEFC5', dark: '#FFEFC5' },
    error: { light: '#EA4965', dark: '#EA4965' },
    successLight: { light: '#84DF8D', dark: '#84DF8D' },
    errorLight: { light: '#FE7B93', dark: '#FE7B93' },
  },

  text: {
    textSecondary: { light: '#666666', dark: '#666666' },
    textMuted: { light: '#868698', dark: '#868698' },
    textDisabled: { light: '#ACACB5', dark: '#ACACB5' },
    textLink: { light: '#4A499B', dark: '#4A499B' },
  },

  surfaces: {
    surfaceElevated: { light: '#F8F8FF', dark: '#F8F8FF' },
    surfaceHighlight: { light: '#E9EBFD', dark: '#303030' },
  },

  neutrals: {
    gray50: { light: '#FAFAFA', dark: '#FAFAFA' },
    gray100: { light: '#F5F5F5', dark: '#F5F5F5' },
    gray200: { light: '#EEEEEE', dark: '#EEEEEE' },
    gray300: { light: '#E0E0E0', dark: '#E0E0E0' },
    gray400: { light: '#BDBDBD', dark: '#BDBDBD' },
    gray500: { light: '#9E9E9E', dark: '#9E9E9E' },
    gray600: { light: '#757575', dark: '#757575' },
    gray800: { light: '#424242', dark: '#424242' },
    gray900: { light: '#212121', dark: '#212121' },
    white: { light: '#ffffff', dark: '#ffffff' },
    black: { light: '#000000', dark: '#000000' },
  },

  extras: {
    whatsapp: { light: '#00E676', dark: '#00E676' },
    statusInactive: { light: '#EFEFEF', dark: '#EFEFEF' },
    snackbar: { light: '#C9AAD1', dark: '#C9AAD1' },
    navyBlue: { light: '#22377E', dark: '#22377E' },
    purpleClean: { light: '#2A244E', dark: '#2A244E' },
    darkPurple: { light: '#1D1938', dark: '#1D1938' },
    nickMenu: { light: '#6567A8', dark: '#6567A8' },
    clientCard: { light: '#595FC0', dark: '#595FC0' },
    totalizer: { light: '#6CAFE0', dark: '#6CAFE0' },
    protectedBlue: { light: '#587BBB', dark: '#587BBB' },
    steelBlue: { light: '#5A8BB0', dark: '#5A8BB0' },
    lightBlueChip: { light: '#CCE9F9', dark: '#CCE9F9' },
    lightPinkChip: { light: '#FDDDEF', dark: '#FDDDEF' },
    lightPurpleButton: { light: '#CECCFF', dark: '#CECCFF' },
    buttonPurple: { light: '#D6DAFF', dark: '#D6DAFF' },
    appgradientcolor: {
      light: 'linear-gradient(164deg, color-mix(in srgb, #5553D2 40%, transparent) 0%, color-mix(in srgb, #6461F8 40%, transparent) 40%, color-mix(in srgb, #FF95A8 50%, transparent) 75%, color-mix(in srgb, #2D2D2D 40%, transparent) 91%)',
      dark: '#1f1f1f',
    },
  },
};

const flatten = (mode) => Object.values(themes).reduce(
  (merged, group) => ({
    ...merged,
    ...Object.entries(group).reduce(
      (grouped, [token, value]) => ({
        ...grouped,
        [token]: value[mode],
      }),
      {},
    ),
  }),
  {},
);

export const lightTheme = flatten('light');
export const darkTheme = flatten('dark');
export const groupedTokens = Object.keys(themes).reduce(
  (acc, key) => ({
    ...acc,
    [key]: Object.keys(themes[key]),
  }),
  {},
);

export default themes;
